import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccessAlarmIcon(props: IconProps) {
    return <Icon {...props} iconKey={"access_alarm"}/>
}
